// ============================================
// READY ORDERS PANEL COMPONENT
// Shows list of ready orders waiting to be served
// Extracted from POSPageV2.jsx
// ============================================

import React from 'react';
import { Bell, Volume2, VolumeX, X, Users, Clock, CheckCircle } from 'lucide-react';

const ReadyOrdersPanel = ({ orders, onDismiss, onServed, soundEnabled, onToggleSound }) => {
    if (!orders || orders.length === 0) return null;
    
    return (
        <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-right duration-300">
            <div className="bg-green-600 text-white rounded-xl shadow-2xl overflow-hidden max-w-sm">
                {/* Header */}
                <div className="bg-green-700 px-4 py-3 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Bell className="h-5 w-5 animate-bounce" />
                        <span className="font-bold text-lg">
                            {orders.length} commande{orders.length > 1 ? 's' : ''} prête{orders.length > 1 ? 's' : ''} !
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <button 
                            onClick={onToggleSound}
                            className="p-1 hover:bg-green-600 rounded"
                            title={soundEnabled ? "Désactiver le son" : "Activer le son"}
                        >
                            {soundEnabled ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
                        </button>
                        <button 
                            onClick={onDismiss}
                            className="p-1 hover:bg-green-600 rounded"
                        >
                            <X className="h-4 w-4" />
                        </button>
                    </div>
                </div>
                
                {/* Orders List */}
                <div className="max-h-64 overflow-y-auto">
                    {orders.map((order) => (
                        <div 
                            key={order.order_id} 
                            className="px-4 py-3 border-b border-green-500 last:border-0 hover:bg-green-500/50 transition-colors"
                        >
                            <div className="flex items-center justify-between">
                                <div>
                                    <div className="font-bold flex items-center gap-2">
                                        <Users className="h-4 w-4" />
                                        {order.table_number ? `Table ${order.table_number}` : 'À emporter'}
                                    </div>
                                    <div className="text-sm text-green-100">
                                        {order.items?.map(i => `${i.quantity}x ${i.name}`).join(', ')}
                                    </div>
                                    <div className="text-xs text-green-200 flex items-center gap-1 mt-1">
                                        <Clock className="h-3 w-3" />
                                        Prêt depuis {order.ready_since || '< 1'} min
                                    </div>
                                </div>
                                <button
                                    onClick={() => onServed(order.order_id)}
                                    className="bg-white text-green-700 px-3 py-1.5 rounded-lg font-bold text-sm hover:bg-green-100 transition-colors flex items-center gap-1"
                                >
                                    <CheckCircle className="h-4 w-4" />
                                    Servi
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ReadyOrdersPanel;
